import React, { useMemo } from 'react';
import { useFragment } from 'react-relay/hooks';

import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  Smartphone as SmartphoneIcon,
  WhatsApp as WhatsAppIcon,
} from '@material-ui/icons';
import { graphql } from 'babel-plugin-relay/macro';
import { SvgIconWrapper, SvgIconWrapperProps } from 'embeds/components';

import { IconPatientContactType_EmbedPatientContact$key } from './__generated__/IconPatientContactType_EmbedPatientContact.graphql';

export interface IconPatientContactTypeProps extends Omit<SvgIconWrapperProps, 'classes' | 'Icon'> {
  fragmentRef: IconPatientContactType_EmbedPatientContact$key;
}

const IconPatientContactType: React.FC<IconPatientContactTypeProps> = ({ fragmentRef, ...rest }) => {
  const { type } = useFragment<IconPatientContactType_EmbedPatientContact$key>(
    graphql`
      fragment IconPatientContactType_EmbedPatientContact on PatientContact {
        type
      }
    `,
    fragmentRef,
  );

  const Icon = useMemo(() => {
    switch (type) {
      case 'voice':
        return PhoneIcon;
      case 'email':
        return EmailIcon;
      case 'whatsapp':
        return WhatsAppIcon;
      case 'sms':
        return SmartphoneIcon;
      default:
        return null;
    }
  }, [type]);

  if (!Icon) {
    return null;
  }
  return <SvgIconWrapper Icon={Icon} {...rest} />;
};

export default IconPatientContactType;
